import { useState } from 'react'
import { ContentModal } from 'components/organisms/modals/content-modal'
import TermsContent, { Term } from 'containers/common/TermsContent'

interface Props {
	open: boolean
	setOpen: (open: boolean) => void
}

export function TermsAndConditionsModal({ open, setOpen }: Props) {
	return (
		<ContentModal open={open} setOpen={setOpen} isModal={true} title="Terms and Conditions" size="2xl">
			<div>
				<TermsContent term={Term.TermsOfService} />
			</div>
		</ContentModal>
	)
}

// ---------------------------------------------------------------------------
// Modal Manager integration
// ---------------------------------------------------------------------------

export interface TermsAndConditionsModalManagedProps {}

declare module 'components/organisms/modals/modal-registry' {
	interface ModalRegistry {
		'terms-and-conditions': TermsAndConditionsModalManagedProps
	}
}

export function ManagedTermsAndConditionsModal({
	onClose,
}: TermsAndConditionsModalManagedProps & { onClose: () => void }) {
	const [open, setOpen] = useState(true)

	const handleClose = () => {
		setOpen(false)
		setTimeout(onClose, 200)
	}

	return (
		<TermsAndConditionsModal
			open={open}
			setOpen={(v: boolean) => { if (!v) handleClose() }}
		/>
	)
}
